// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"JOAIB","separator":"DL2Tb","listContainer":"_9ywvO"};